import { DisposalPlacesContentModel } from './disposalPlacesContent'

export class DisposalPlacesModel {
    public disposalPlaceId: number;
    public city: string;
    public region: string;
    public address: string;
    public interval?: string;
    public description: string;
    public latitude: number;
    public longtitude: number;
    public date: string;
    public disposalPlacesContent: Array<DisposalPlacesContentModel>
}